/**
 * AdvisorTableSkeleton Component (T131 - US6)
 * Loading skeleton for advisor table
 */

type AdvisorTableSkeletonProps = {
  rows?: number;
};

/**
 * Skeleton component displayed while advisor table data is loading
 * 
 * @param rows - Number of skeleton rows to display (default: 10)
 */
export function AdvisorTableSkeleton({ rows = 10 }: AdvisorTableSkeletonProps) {
  return (
    <div className="space-y-3">
      {/* Table header skeleton */}
      <div className="flex items-center gap-4 px-4 py-3 bg-gray-50 rounded-md">
        <div className="h-4 w-32 bg-gray-200 rounded animate-pulse" />
        <div className="h-4 w-40 bg-gray-200 rounded animate-pulse" />
        <div className="h-4 w-24 bg-gray-200 rounded animate-pulse" />
        <div className="h-4 w-24 bg-gray-200 rounded animate-pulse" />
        <div className="h-4 w-20 bg-gray-200 rounded animate-pulse" />
        <div className="h-4 w-16 bg-gray-200 rounded animate-pulse ml-auto" />
      </div>

      {/* Table rows skeleton */}
      {Array.from({ length: rows }).map((_, index) => (
        <div
          key={index}
          className="flex items-center gap-4 px-4 py-4 bg-white border border-gray-200 rounded-md"
        >
          {/* Name skeleton (with email subtitle) */}
          <div className="flex-1 space-y-1.5">
            <div className="h-4 w-40 bg-gray-200 rounded animate-pulse" />
            <div className="h-3 w-56 bg-gray-100 rounded animate-pulse" />
          </div>
          
          {/* Firm skeleton */}
          <div className="flex-1">
            <div className="h-4 w-48 bg-gray-200 rounded animate-pulse" />
          </div>
          
          {/* Total Clients skeleton */}
          <div className="h-4 w-12 bg-gray-200 rounded animate-pulse" />
          
          {/* Active Clients skeleton */}
          <div className="h-4 w-12 bg-gray-200 rounded animate-pulse" />
          
          {/* Join date skeleton */}
          <div className="h-4 w-24 bg-gray-200 rounded animate-pulse" />
          
          {/* Actions skeleton */}
          <div className="flex gap-2">
            <div className="h-8 w-8 bg-gray-200 rounded animate-pulse" />
            <div className="h-8 w-8 bg-gray-200 rounded animate-pulse" />
          </div>
        </div>
      ))}
    </div>
  );
}

